import { NavLink } from "react-router-dom"
import Faq from "./faq"
import { useEffect } from "react"
import { CONTACT_CONFIG } from '../config/contact'

export default function Reimbursement() {
    // Utilisation des variables de configuration centralisées
    const contactInfo = CONTACT_CONFIG;
    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);
    }, []);

    const scrollToTop = () => {
        window.scrollTo(0, 0);
    };

    return (
        <>
            {/* Header Section */}
            <section className="bg-gradient-to-r from-[#0a1a5f] via-[#002f9c] to-[#0d47ff] text-white py-8 relative overflow-hidden">
                {/* Background Decoration */}
                <div className="absolute top-0 right-0 w-96 h-96 bg-white opacity-5 rounded-full -translate-y-48 translate-x-48"></div>
                <div className="absolute bottom-0 left-0 w-64 h-64 bg-white opacity-5 rounded-full translate-y-32 -translate-x-32"></div>
                
                <div className="h-[25vh]"></div>
                <div className="main-content relative z-10">        
                    {/* Main Title */}
                    <div className="text-center">
                        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-3">
                            Politique de 
                            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-400">
                                Remboursement
                            </span>
                        </h1>
                    </div>
                    {/* Navigation Breadcrumbs */}
                    <div className="text-center mb-4">
                        <span className="text-sm">
                            <NavLink 
                                to="/" 
                                className="transition-all duration-500 hover:text-yellow-400"
                                onClick={scrollToTop}
                            >
                                Accueil
                            </NavLink> / <span className="text-gray-300">Politique de Remboursement</span>
                        </span>
                    </div>
                </div>
            </section>

            {/* Content Section */}
            <section className="py-5 sm:py-12 relative overflow-hidden">
                {/* Background Pattern */}
                <div className="absolute inset-0 opacity-20">
                    <div className="h-64 w-full" style={{
                        backgroundImage: `radial-gradient(circle, #3b82f6 1px, transparent 1px)`,
                        backgroundSize: '20px 20px'
                    }}></div>
                </div>
                
                <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto relative z-10">
                    <div className="space-y-8">
                        {/* Section 1 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#0a1a5f] to-[#002f9c] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">1</span>
                                </div>
                                Droit au remboursement
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                                Chez TVLUXO, nous nous engageons à garantir votre satisfaction. C'est pourquoi nous offrons une politique de remboursement de 15 jours pour tous nos utilisateurs. Si, pour une raison quelconque, vous n'êtes pas satisfait de nos services, vous pouvez demander un remboursement dans les 15 jours suivant votre achat.
                            </p>
                        </div>

                        {/* Section 2 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#002f9c] to-[#0d47ff] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">2</span>
                                </div>
                                Conditions de remboursement
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-4">
                                Pour être éligible à un remboursement, les conditions suivantes doivent être remplies :
                            </p>
                            <ul className="list-disc list-inside space-y-2 text-sm sm:text-base text-gray-600">
                                <li>La demande doit être faite dans les 15 jours suivant la date d'achat.</li>
                                <li>Vous devez fournir une preuve d'achat valide, comme votre reçu ou e-mail de confirmation.</li>
                                <li>Les remboursements ne sont pas disponibles si vous avez déjà utilisé plus de 50% de votre période d'abonnement.</li>
                            </ul>
                        </div>

                        {/* Section 3 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#0d47ff] to-[#1d4ed8] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">3</span>
                                </div>
                                Processus de demande
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-4">
                                Pour demander un remboursement, suivez ces étapes :
                            </p>
                            <ol className="list-inside list-decimal space-y-2 text-sm sm:text-base text-gray-600">
                                <li>Contactez notre équipe de support via WhatsApp ou e-mail.</li>
                                <li>Fournissez votre numéro de commande et la raison du remboursement.</li>
                                <li>Joignez la preuve d'achat (reçu ou e-mail de confirmation).</li>
                            </ol>
                        </div>

                        {/* Section 4 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#1d4ed8] to-[#3b82f6] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">4</span>
                                </div>
                                Méthode de remboursement
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                                Si votre demande de remboursement est approuvée, le montant sera remboursé via le même mode de paiement que celui utilisé lors de votre achat. Le temps de traitement peut varier selon votre fournisseur de paiements.
                            </p>
                        </div>

                        {/* Section 5 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#3b82f6] to-[#60a5fa] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">5</span>
                                </div>
                                Contactez-nous
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-4">
                                Pour toute question concernant cette politique de remboursement ou pour exercer vos droits, 
                                vous pouvez nous contacter via :
                            </p>
                            <ul className="list-disc list-inside space-y-2 text-sm sm:text-base text-gray-600">
                                <li>Email : {contactInfo.email}</li>
                                <li>
                                    WhatsApp :{" "}
                                    <a 
                                        href={contactInfo.whatsappUrl} 
                                        target="_blank" 
                                        rel="noopener noreferrer"   
                                        className="text-blue-600 underline hover:text-blue-800 transition-colors duration-300"
                                    >
                                        Cliquez ici pour nous contacter
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/* Conclusion */}
                        <div className="bg-gradient-to-r from-[#0a1a5f] to-[#002f9c] rounded-2xl p-6 sm:p-8 text-white shadow-xl">
                            <div className="text-center">
                                <h3 className="text-lg sm:text-xl font-bold mb-4">
                                    Merci d'avoir choisi {contactInfo.companyName}
                                </h3>
                                <p className="text-sm sm:text-base leading-relaxed opacity-90">
                                    Nous sommes fiers de garantir votre confidentialité et de vous offrir 
                                    un service de haute qualité sans compromettre votre sécurité ou votre anonymat.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <Faq/>
            </section>
            
        </>
    )
}
